var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"px-6 py-6",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"border-radius-xl card-shadow"},[_c('div',{staticClass:"px-4 py-4 mt-2"},[_c('LessonTable',{attrs:{"path":_vm.path,"headerNames":[
                'Xичээлийн нэр',
                'Xичээлийн төрөл',
                'Багшийн нэр',
                'Төрөл',
                'Үйлдэл',
              ],"addButtonText":'Xичээл'}})],1)])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }